<template>
    <div class="container" id="content">
        <!-- 导航栏 -->
        <div style="width:100%;height:100%;">
            <section id="zz" v-if="isZH" style="">
                <div class="flex-row-between" style="position: fixed;top: 0;left:0;background: #e8e8e8;z-index: 99;width:100%;padding:20px 300px;box-sizing:border-box;">
                    <img src="../../static/new/logo.png" alt="" data-aos="zoom-in" style="height:80px;">
                    <div class="flex-row-between sub-c" style="width: 775px;height: 100px;background: #D9D9D9;border-radius: 100px;border: 2px solid #463651;padding:0 25px;box-sizing:border-box;">
                        <span :class="['nav',navActive=='aa' ? 'nav-active' : '']" @click="scrollTo('aa')">關於我們</span>
                        <span :class="['nav',navActive=='bb' ? 'nav-active' : '']" @click="scrollTo('bb')">核心業務</span>
                        <span :class="['nav',navActive=='ee' ? 'nav-active' : '']" @click="scrollTo('ee')">聯繫我們</span>
                    </div>
                    <div class="flex-row-center">
                        <div @click="isZH=!isZH" class="lang">{{isZH?'En':'Zh'}}</div>
                    </div>
                </div>
                <div class="flex-row-between" style="width:100%;padding-top: 200px;">
                    <div style="flex-row-between">
                        <div style="width:100%;position:relative;">
                            <img src="../../static/new/1.4.png" alt="" data-aos="fade-right" style="height:220px;">
                            <img src="../../static/new/1.5.png" alt="" data-aos="fade-up-right" class="right-top-img" style="position:absolute;bottom:20px;left:380px;width:200px;">
                        </div>
                        <div class="sub-c" style="font-size: 28px;line-height: 38px;margin-top:45px;">
                            Crowdstar通過持續創新與大膽突破，將 <span style="color:#AE86E7;font-size:25px;font-weight:bold;">廣告與遊戲</span>
                            完美融合，爲客戶創造<span style="color:#AE86E7;font-size:25px;font-weight:bold;">非凡價值</span>，引領行業潮流。
                        </div>
                        <div class="ture-greed" style="background: #AF85E7;box-shadow: 4px 8px 0px 0px #000000;border-radius: 129px;border: 1px solid #463651;display:inline-block;padding: 23px 40px;margin-top:45px;">
                            <span class="main-t" style="font-size: 33px;color: #FFFFFF;">立即開始</span>
                        </div>
                    </div>
                    <img src="../../static/new/1.3.png" alt="" class="rotate" style="height:600px;" data-aos="fade-left">
                </div>
            </section>
            <section id="zz" v-else style="">
                <div class="flex-row-between" style="position: fixed;top: 0;left:0;background: #e8e8e8;z-index: 99;width:100%;padding:20px 300px;box-sizing:border-box;">
                    <img src="../../static/new/logo.png" alt="" data-aos="zoom-in" style="height:80px;">
                    <div class="flex-row-between sub-c" style="width: 775px;height: 100px;background: #D9D9D9;border-radius: 100px;border: 2px solid #463651;padding:0 25px;box-sizing:border-box;">
                        <span :class="['nav',navActive=='aa' ? 'nav-active' : '']" @click="scrollTo('aa')">About Us</span>
                        <span :class="['nav',navActive=='bb' ? 'nav-active' : '']" @click="scrollTo('bb')">Core Business</span>
                        <span :class="['nav',navActive=='ee' ? 'nav-active' : '']" @click="scrollTo('ee')">Contact Us</span>
                    </div>
                    <div class="flex-row-center">
                        <div @click="isZH=!isZH" class="lang">{{isZH?'En':'Zh'}}</div>
                    </div>
                </div>
                <div class="flex-row-between" style="width:100%;padding-top: 200px;">
                    <div style="flex-row-between">
                        <div style="width:100%;position:relative;">
                            <img src="../../static/new/1.1.png" alt="" data-aos="fade-right" style="height:220px;">
                            <img src="../../static/new/1.2.png" alt="" data-aos="fade-up-right" class="right-top-img" style="position:absolute;bottom:20px;left:450px;width:200px;">
                        </div>
                        <div class="sub-c" style="font-size: 28px;line-height: 38px;margin-top:20px;">
                            Crowdstar blends <span style="color:#AE86E7;font-size:25px;font-weight:bold;">advertising and gaming</span> with
                            continuous innovation and bold progress, delivering
                            <span style="color:#AE86E7;font-size:25px;font-weight:bold;">exceptional value</span> to clients and leading industry<br/>
                            trends.
                        </div>
                        <div class="ture-greed" style="background: #AF85E7;box-shadow: 4px 8px 0px 0px #000000;border-radius: 129px;border: 1px solid #463651;display:inline-block;padding: 23px 40px;margin-top:45px;">
                            <span class="main-t" style="font-size: 33px;color: #FFFFFF;">Get Started</span>
                        </div>
                    </div>
                    <img src="../../static/new/1.3.png" alt="" class="rotate" style="height:600px;" data-aos="fade-left">
                </div>
            </section>
        </div>

        <!-- 公司簡介 -->
        <div style="width:100%; height:100%; overflow: hidden;margin-top:80px;">
            <section id="aa" v-if="isZH" class="flex-row-between" style="">
                <div class="flex-row-center" style="flex:1;width:100%;height:100%;;box-sizing:border-box;">
                    <div style="position: relative;">
                        <img src="../../static/new/2.1.png" class="rotate" alt="" style="width:600px;margin-right:20px;">
                        <img src="../../static/new/2.11.png" class="shanshuo" alt="" style="width:35px;position:absolute;top:70px;left:250px;">
                        <img src="../../static/new/2.12.png" class="shanshuo" alt="" style="width:35px;position:absolute;top:30px;right:150px;">
                        <img src="../../static/new/2.13.png" class="shanshuo" alt="" style="width:48px;position:absolute;bottom:50px;right:100px;">
                        <img src="../../static/new/2.14.png" class="shanshuo" alt="" style="width:100px;position:absolute;bottom:0;left:60px;">
                    </div>
                    <div class="" style="position: relative;">
                        <div>
                            <div class="main-t nav-t" style="display:inline-block;text-align:left;">
                                <div class="flex-row-center">
                                    <span style="margin-right:40px;">關於我們</span>
                                    <img src="../../static/new/Icon.png" alt=""  style="width:60px;">
                                </div>
                            </div>
                        </div>
                        <div class="main-t bg-greed" style="margin:80px 0 40px;">CROWDSTAR TECHNOLOGY LIMITED</div>  
                        <div class="sub-c" style="color:#fff;">
                            以 “持續創新，勇毅前行，爲客戶鑄就輝煌” 爲使命，是一家<span style="color:#D5F277;font-size:25px;font-weight:bold;">融合廣告營銷與遊</span>
                            <span style="color:#D5F277;font-size:25px;font-weight:bold;">戲開髮運營</span>
                            的綜合性科技企業。我們憑藉 “創新驅動、業務增長” 的核心理唸，
                            將廣告服務與遊戲産業深度結合，爲合作夥伴與用戶創造雙重價值，緻力於成爲
                            行業髮展趨勢的引領者。
                        </div>
                        <img src="../../static/new/2.2.png" alt="" class="right-top-img" style="position:absolute;top:0;right:30px;width:200px;">
                    </div>
                </div>
            </section>
            <section id="aa" v-else class="flex-row-between" style="">
                <div class="flex-row-center" style="flex:1;width:100%;height:100%;;box-sizing:border-box;">
                    <div style="position: relative;">
                        <img src="../../static/new/2.1.png" class="rotate" alt="" style="width:600px;margin-right:20px;">
                        <img src="../../static/new/2.11.png" class="shanshuo" alt="" style="width:35px;position:absolute;top:70px;left:250px;">
                        <img src="../../static/new/2.12.png" class="shanshuo" alt="" style="width:35px;position:absolute;top:30px;right:150px;">
                        <img src="../../static/new/2.13.png" class="shanshuo" alt="" style="width:48px;position:absolute;bottom:50px;right:100px;">
                        <img src="../../static/new/2.14.png" class="shanshuo" alt="" style="width:100px;position:absolute;bottom:0;left:60px;">
                    </div>
                    <div class="" style="position: relative;">
                        <div>
                            <div class="main-t nav-t" style="display:inline-block;text-align:left;">
                                <div class="flex-row-center">
                                    <span style="margin-right:40px;">About Us</span>
                                    <img src="../../static/new/Icon.png" alt=""  style="width:60px;">
                                </div>
                            </div>
                        </div>
                        <div class="main-t bg-greed" style="margin:80px 0 40px;">CROWDSTAR TECHNOLOGY LIMITED</div>  
                        <div class="sub-c" style="color:#fff;">
                            With a mission to ‘pursue continuous innovation, advance with courage
                            and determination, and forge brilliance for our clients,’ we are a
                            comprehensive technology enterprise <span style="color:#D5F277;font-size:25px;font-weight:bold;">integrating advertising </span>
                            <span style="color:#D5F277;font-size:25px;font-weight:bold;">marketing with game development and operations</span>. Guided
                            by our core philosophy of ‘innovation-driven business growth,’ we deeply
                            integrate advertising services with the gaming industry, creating dual
                            value for partners and users alike. We are committed to becoming a
                            trendsetter in the sector's development.
                        </div>
                        <img src="../../static/new/2.2.png" alt="" class="right-top-img" style="position:absolute;top:0;right:30px;width:200px;">
                    </div>
                </div>
            </section>
        </div>
        
        <!-- 我們的優勢 -->
        <div style="width:100%; overflow: hidden;margin-top:80px;">
            <section id="bb" v-if="isZH" style="">
                <div class="flex-row-center" style="margin-bottom:80px;">
                    <div class="main-t nav-t" style="display:inline-block;">
                        <div class="flex-row-center">
                            <span style="margin-right:40px;">核心業務</span>
                            <img src="../../static/new/Icon.png" alt=""  style="width:60px;">
                        </div>
                    </div>
                </div>
                <div style="width:100%;height:425px;background: #F3F3F3;border-radius: 60px;position: relative;padding:60px 80px;box-sizing:border-box;">
                    <div class="main-t bg-greed" style="">雙輪驅動</div>
                    <div class="sub-t" style="margin-top:60px;margin-bottom:10px;">覆蓋</div>  
                    <div class="main-t" style="color: #AF84EC;"> 遊戲産業全鏈條</div>
                    <img src="../../static/new/3.1.png" alt="" class="shanshuo-slow" style="position:absolute;bottom:50px;right:100px;width:490px;">
                </div>
            </section>
            <section id="bb" v-else style="">
                <div class="flex-row-center" style="margin-bottom:80px;">
                    <div class="main-t nav-t" style="display:inline-block;">
                        <div class="flex-row-center">
                            <span style="margin-right:40px;">Core Business</span>
                            <img src="../../static/new/Icon.png" alt=""  style="width:60px;">
                        </div>
                    </div>
                </div>
                <div style="width:100%;height:425px;background: #F3F3F3;border-radius: 60px;position: relative;padding:60px 80px;box-sizing:border-box;">
                    <div class="main-t bg-greed" style="">Dual-drive strategy</div>
                    <div class="sub-t" style="margin-top:60px;margin-bottom:10px;">Covering the</div>  
                    <div class="main-t" style="color: #AF84EC;"> Entire gaming industry chain</div>
                    <img src="../../static/new/3.1.png" alt="" class="shanshuo-slow" style="position:absolute;bottom:50px;right:100px;width:490px;">
                </div>
            </section>
        </div>

        <!-- 核心價值觀 -->
        <div style="width:100%; overflow: hidden;margin-top:120px;">
            <section id="cc" v-if="isZH" style="position:relative;width:100%;">
                <div class="flex-column-center" style="width:100%;">
                    <div class="main-t bg-purple">廣告代理服務</div>
                    <div class="sub-t" style="margin: 40px 0 80px">精準觸達，爲遊戲增長賦能</div>
                </div>
                <div v-for="(item,index) in whList" :key="index" @mouseenter="overWH(index)"
                    :style="{background:item.active?'#D5F277':'#F3F3F3',boxShadow: '0px 5px 0px 0px #191A23',borderRadius: '45px',border: '1px solid #191A23',marginBottom:'40px',padding:'40px 60px 60px',}">
                    <div class="flex-row-between" style="">
                        <div class="sub-t" style="">
                            <span style="font-size: 45px;margin-right:20px;">{{`0${index+1}`}}</span>
                            <span style="font-weight:bold !important;">{{item.zh}}</span>
                        </div>
                        <img :src="require(`../../static/new/${item.active?'4.0.png':'4.00.png'}`)" alt="" style="width:60px;cursor: pointer;margin-top:20px;">
                    </div>
                    <div v-show="item.active">
                        <div style="width:100%;height:1px;background:#000;margin: 40px 0 20px;">&nbsp;</div>
                        <div class="flex-row-between" style="flex:1;width:100%;">
                            <div class="sub-c" style="text-align:left;">
                                <div v-for="(child,ind) in item.zhC.split('<br/>')" :key="ind">{{child}}</div>
                            </div>
                            <img :src="require(`../../static/new/4.${index+1}.png`)" alt="" style="width:520px;">
                        </div>
                    </div>
                </div>
            </section>
            <section id="cc" v-else style="position:relative;width:100%;">
                <div class="flex-column-center" style="width:100%;">
                    <div class="main-t bg-purple">Advertising agency services</div>
                    <div class="sub-t" style="margin: 40px 0 80px">Precise targeting to empower game growth</div>
                </div>
                <div v-for="(item,index) in whList" :key="index" @mouseenter="overWH(index)"
                    :style="{background:item.active?'#D5F277':'#F3F3F3',boxShadow: '0px 5px 0px 0px #191A23',borderRadius: '45px',border: '1px solid #191A23',marginBottom:'40px',padding:'40px 60px 60px',}">
                    <div class="flex-row-between" style="">
                        <div class="sub-t" style="">
                            <span style="font-size: 45px;margin-right:20px;">{{`0${index+1}`}}</span>
                            <span style="font-weight:bold !important;">{{item.en}}</span>
                        </div>
                        <img :src="require(`../../static/new/${item.active?'4.0.png':'4.00.png'}`)" alt="" style="width:60px;cursor: pointer;margin-top:20px;">
                    </div>
                    <div v-show="item.active">
                        <div style="width:100%;height:1px;background:#000;margin: 40px 0 20px;">&nbsp;</div>
                        <div class="flex-row-between" style="flex:1;width:100%;">
                            <div class="sub-c" style="text-align:left;">
                                <div v-for="(child,ind) in item.enC.split('<br/>')" :key="ind">{{child}}</div>
                            </div>
                            <img :src="require(`../../static/new/4.${index+1}.png`)" alt="" style="width:520px;">
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- 业务介绍 -->
        <div style="width:100%; height: 100%; overflow: hidden;margin-top:80px;">
            <section id="dd" v-if="isZH" style="">
                <div class="flex-column-center" style="width:100%;">
                    <div class="main-t bg-greed">遊戲開髮運營</div>
                    <div class="sub-t" style="margin: 40px 0 80px">精品化佈局，深耕用戶體驗</div>
                    <div class="sub-c" style="margin-bottom:80px;text-align:center;">
                        我們深耕<span style="color:#AE86E7;font-size:25px;font-weight:bold;">遊戲開髮、運營、推廣與維護全鏈路</span>，目前已在Google Play成功髮行多款遊戲，以 “ <span style="color:#AE86E7;font-size:25px;font-weight:bold;">輕量級、強體驗</span>” 爲産品特<br/> 
                        色。從遊戲研髮初期的玩法打磨，到上線後的運營活動策劃、用戶反饋收集及版本更新維護，我們始終以用戶體驗爲核心，通過持<br/>
                        續優化提昇遊戲生命週期與用戶留存。
                    </div>
                </div>
                <div style="width:100%; background: #181D33;border-radius: 60px;padding: 100px;box-sizing: border-box;">
                    <div class="flex-row-between" style="margin-bottom: 100px;">
                        <div style="display: flex;align-items: center;">
                            <div class="sub-t bg-greed" style="margin-right: 36px;">益智類遊戲</div>
                            <div class="sub-c" style="color: #FFFFFF;line-height: 38px;text-align:left;">聚焦休閒益智玩法，通過趣味關卡設計與輕量化操作，滿足用戶碎片化娛樂需求</div>
                        </div>
                        <img src="../../static/new/5.1.png" alt="" @click="changeGame"
                            :style="{width:'72px',height:'72px',transform:ysActive==1?'rotate(0deg)':'rotate(180deg)', cursor:'pointer'}">
                    </div>
                    <swiper ref="mySwiper" :options="swiperOption" class="horizontal-swiper" style="">
                        <swiper-slide v-for="(item,index) in ysList" :key="index">
                            <div class="flex-column-center" style="width:800px;border-radius: 20px;border: 1px solid #B9FF66;padding:24px; box-sizing: border-box;"> 
                                <div class="flex-row-between" style="width:100%;">
                                    <template v-if="item.imgList.length==1">
                                        <img :src="require(`../../static/new/${item.imgList[0]}`)" alt="" style="width:770px;">
                                    </template>
                                    <template v-else>
                                        <img v-for="(child,ind) in item.imgList" :key="ind" :src="require(`../../static/new/${child}`)" alt="" style="width:230px;">
                                    </template>
                                </div>
                                <div class="flex-row-between" style="width:100%;margin-top: 30px;">
                                    <div class="flex-row-center">
                                        <img :src="require(`../../static/new/${item.img}`)" alt=""  style="width:100px;">
                                        <div>
                                            <div v-for="(child,ind) in item.name.split('<br/>')" :key="ind" 
                                                style="margin-left: 28px;color: #D5F277;font-size: 23px;font-weight: 500;">
                                                {{child}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bg-greed ture-purple" @click="toLink(item.link)"
                                        style="font-size:23px;padding:16px 20px;color: #000000;background: linear-gradient( 360deg, #D2F26D 0%, #B9FF66 100%);border-radius: 100px;">
                                        {{isZH?'查看遊戲':'View Game'}}
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="flex-row-center" style="margin-top:70px;margin-bottom:-50px;">
                        <div @mouseenter="hoverLeft=true" @mouseleave="hoverLeft=false">
                            <img v-show="!hoverLeft" src="../../static/new/arrow2.png" alt="Previous" @click="goPrevSlide"
                                style="width:26px;transform: rotate(0deg);cursor: pointer;"> 
                            <img v-show="hoverLeft" src="../../static/new/arrow1.png" alt="Previous" @click="goPrevSlide"
                                style="width:26px;transform: rotate(180deg);cursor: pointer;"> 
                        </div>
                        <div style="margin:0 220px;">
                            <img v-for="(item, index) in ysList" :key="index" style="width:18px;margin:0 13px;"
                                :src="require(`../../static/new/${activeIndex==index?'star1':'star2'}.png`)" alt="">
                        </div>
                        <div @mouseenter="hoverRight=true" @mouseleave="hoverRight=false">
                            <img v-show="!hoverRight" src="../../static/new/arrow2.png" alt="Previous" @click="goNextSlide"
                                style="width:26px;transform: rotate(180deg);cursor: pointer;"> 
                            <img v-show="hoverRight" src="../../static/new/arrow1.png" alt="Previous" @click="goNextSlide"
                                style="width:26px;transform: rotate(0deg);cursor: pointer;"> 
                        </div>
                    </div>
                </div>
            </section>
            <section id="dd" v-else style="">
                <div class="flex-column-center" style="width:100%;">
                    <div class="main-t bg-greed">Game Development and Operation</div>
                    <div class="sub-t" style="margin: 40px 0 80px">Focusing on Quality and User Experience</div>
                    <div class="sub-c" style="margin-bottom:80px;text-align:center;">
                        We specialise in <span style="color:#AE86E7;font-size:25px;font-weight:bold;">the entire lifecycle of game development, operations, promotion and maintenance</span>. <br/>
                        Having successfully launched multiple titles on Google Play, our products are characterised by being <span style="color:#AE86E7;font-size:25px;font-weight:bold;">lightweight yet</span><br/> 
                        <span style="color:#AE86E7;font-size:25px;font-weight:bold;">delivering a rich experience</span>. From refining gameplay mechanics during early development stages to planning post-
                        launch operational activities, gathering user feedback and managing version updates, we consistently prioritise user
                        experience. Through continuous optimisation, we enhance game lifecycle and user retention.
                    </div>
                </div>
                <div style="width:100%; background: #181D33;border-radius: 60px;padding: 100px;box-sizing: border-box;">
                    <div class="flex-row-between" style="margin-bottom: 100px;">
                        <div style="display: flex;align-items: center;">
                            <div class="sub-t bg-greed" style="margin-right: 36px;">Puzzle Games</div>
                            <div class="sub-c" style="color: #FFFFFF;line-height: 38px;text-align:left;">Casual puzzles with fun levels and lightweight controls for fragmented<br/> entertainment.</div>
                        </div>
                        <img src="../../static/new/5.1.png" alt="" @click="changeGame"
                            :style="{width:'72px',height:'72px',transform:ysActive==1?'rotate(0deg)':'rotate(180deg)', cursor:'pointer'}">
                    </div>
                    <swiper ref="mySwiper" :options="swiperOption" class="horizontal-swiper" style="">
                        <swiper-slide v-for="(item,index) in ysList" :key="index">
                            <div class="flex-column-center" style="width:800px;border-radius: 20px;border: 1px solid #B9FF66;padding:24px; box-sizing: border-box;"> 
                                <div class="flex-row-between" style="width:100%;">
                                    <template v-if="item.imgList.length==1">
                                        <img :src="require(`../../static/new/${item.imgList[0]}`)" alt="" style="width:770px;">
                                    </template>
                                    <template v-else>
                                        <img v-for="(child,ind) in item.imgList" :key="ind" :src="require(`../../static/new/${child}`)" alt="" style="width:230px;">
                                    </template>
                                </div>
                                <div class="flex-row-between" style="width:100%;margin-top: 30px;">
                                    <div class="flex-row-center">
                                        <img :src="require(`../../static/new/${item.img}`)" alt=""  style="width:100px;">
                                        <div>
                                            <div v-for="(child,ind) in item.name.split('<br/>')" :key="ind" 
                                                style="margin-left: 28px;color: #D5F277;font-size: 23px;font-weight: 500;">
                                                {{child}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bg-greed ture-purple" @click="toLink(item.link)"
                                        style="font-size:23px;padding:16px 20px;color: #000000;background: linear-gradient( 360deg, #D2F26D 0%, #B9FF66 100%);border-radius: 100px;">
                                        {{isZH?'查看遊戲':'View Game'}}
                                    </div>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="flex-row-center" style="margin-top:70px;margin-bottom:-50px;">
                        <div @mouseenter="hoverLeft=true" @mouseleave="hoverLeft=false">
                            <img v-show="!hoverLeft" src="../../static/new/arrow2.png" alt="Previous" @click="goPrevSlide"
                                style="width:26px;transform: rotate(0deg);cursor: pointer;"> 
                            <img v-show="hoverLeft" src="../../static/new/arrow1.png" alt="Previous" @click="goPrevSlide"
                                style="width:26px;transform: rotate(180deg);cursor: pointer;"> 
                        </div>
                        <div style="margin:0 220px;">
                            <img v-for="(item, index) in ysList" :key="index" style="width:18px;margin:0 13px;"
                                :src="require(`../../static/new/${activeIndex==index?'star1':'star2'}.png`)" alt="">
                        </div>
                        <div @mouseenter="hoverRight=true" @mouseleave="hoverRight=false">
                            <img v-show="!hoverRight" src="../../static/new/arrow2.png" alt="Previous" @click="goNextSlide"
                                style="width:26px;transform: rotate(180deg);cursor: pointer;"> 
                            <img v-show="hoverRight" src="../../static/new/arrow1.png" alt="Previous" @click="goNextSlide"
                                style="width:26px;transform: rotate(0deg);cursor: pointer;"> 
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <!-- 聯繫我們 -->
        <div style="width:100%; font-family: Space Grotesk;font-weight: 400;font-size: 24px;color: #fff;margin-top:160px;">
            <section id="ee" v-if="isZH" class="flex-column-between" style="">
                <img :src="require(`../../static/new/6.1.png`)" alt="" style="position:absolute;top:0px;left:550px;height:400px;">
                <div class="flex-row-between" style="width:100%;height:90px;margin: 40px 0 30px;">
                    <img :src="require(`../../static/new/logo.png`)" alt="" style="height:80px;">
                    <div style="">
                        <span style="" class="footer-link" @click="scrollTo('aa')">關於我們</span>
                        <span style="margin-left: 50px;" class="footer-link" @click="scrollTo('bb')">核心業務</span>
                        <span style="margin-left: 50px;" class="footer-link" @click="scrollTo('ee')">聯繫我們</span>
                    </div>
                </div>
                <div class="flex-row-between" style="flex:1;width:100%;margin-bottom: 50px">
                    <div style="">
                        <div class="bg-greed" style="font-size:27px;margin-bottom:35px;color: #000000;">聯繫我們</div>
                        <div style="">Email: contact@crowdstar-tech.com</div>
                    </div>
                    <div class="flex-row-between" style="background: #D5F277;box-shadow: 0px 5px 0px 0px #191A23;border-radius: 45px;border: 1px solid #191A23;padding:35px 52px;">
                        <div style="border-radius: 19px;border: 1px solid #181D33;padding:27px 47px;width: 160px;color: #181D33;">Email</div>
                        <div style="background: #181D33;border-radius: 19px;padding:27px 47px;margin-left:30px;text-align:center;min-width:160px;">訂閱</div>
                    </div>
                </div>
                <div style="width:100%;height:1px;background:#fff;">&nbsp;</div>
                <div class="flex-row-between" style="width:100%;height:164px;line-height: 164px;">
                    <div style="">© 2025 CROWDSTAR . All Rights Reserved.</div>
                    <div style="color: #fff;">
                        <a href="https://crowdstar-tech.com/PrivacyPolicy.html" target="_blank" style="" class="footer-link">隱私政策</a>
                        <a href="https://crowdstar-tech.com/Service.html" target="_blank" style="margin-left: 50px;" class="footer-link">服務</a>
                    </div>
                </div>
            </section>
            <section id="ee" v-else class="flex-column-between" style="">
                <img :src="require(`../../static/new/6.1.png`)" alt="" style="position:absolute;top:0px;left:550px;height:400px;">
                <div class="flex-row-between" style="width:100%;height:90px;margin: 40px 0 30px;">
                    <img :src="require(`../../static/new/logo.png`)" alt="" style="height:80px;">
                    <div style="">
                        <span style="" class="footer-link" @click="scrollTo('aa')">About us</span>
                        <span style="margin-left: 50px;" class="footer-link" @click="scrollTo('bb')">Our Services</span>
                        <span style="margin-left: 50px;" class="footer-link" @click="scrollTo('ee')">Contact Us</span>
                    </div>
                </div>
                <div class="flex-row-between" style="flex:1;width:100%;margin-bottom: 50px">
                    <div style="">
                        <div class="bg-greed" style="font-size:27px;margin-bottom:35px;color: #000000;">Contact us</div>
                        <div style="">Email: contact@crowdstar-tech.com</div>
                    </div>
                    <div class="flex-row-between" style="background: #D5F277;box-shadow: 0px 5px 0px 0px #191A23;border-radius: 45px;border: 1px solid #191A23;padding:35px 52px;">
                        <div style="border-radius: 19px;border: 1px solid #181D33;padding:27px 47px;width: 160px;color: #181D33;">Email</div>
                        <div style="background: #181D33;border-radius: 19px;padding:27px 47px;margin-left:30px;text-align:center;min-width:160px;">Subscribe to news</div>
                    </div>
                </div>
                <div style="width:100%;height:1px;background:#fff;">&nbsp;</div>
                <div class="flex-row-between" style="width:100%;height:164px;line-height: 164px;">
                    <div style="">© 2025 CROWDSTAR . All Rights Reserved.</div>
                    <div style="color: #fff;">
                        <a href="https://crowdstar-tech.com/PrivacyPolicy.html" target="_blank" style="" class="footer-link">Privacy Policy</a>
                        <a href="https://crowdstar-tech.com/Service.html" target="_blank" style="margin-left: 50px;" class="footer-link">Service</a>
                    </div>
                </div>
            </section>
        </div>
        
    </div>
</template>
<script>

import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import autofit from 'autofit.js'
import AOS from 'aos';
import 'aos/dist/aos.css';
export default {
    name: 'Index',
    components: {
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            activeIndex: 0,
            swiperOption: {
                navigation: {
                    nextEl: ".swiper-button-next", // 下一个按钮的类名
                    prevEl: ".swiper-button-prev", // 上一个按钮的类名
                    hiddenClass: "my-button-hidden",//隐藏时的class
                    disabledClass: 'my-button-disabled',//不可用时的class
                },
                slidesPerView: '2',
                // centeredSlides: true,
                width: 1700,
                spaceBetween : 100,
                // slidesOffsetBefore: 100,
                slidesOffsetAfter: 900,
                simulateTouch: false,
                // mousewheelControl: true,
                // forceToAxis: true,
                // mousewheel: { // 鼠标轮
                //     sensitivity : 0.1,  // 滑动灵敏度
                // },
            },
            navbar: [
                {zh:'公司簡介', en:'Company Profile', id:'aa'},
                {zh:'我們的優勢', en:'Our Advantages', id:'bb'},
                {zh:'核心價值觀', en:'Core Values', id:'cc'},
                {zh:'業務介紹', en:'Our Strengths', id:'dd'},
                {zh:'聯繫我們', en:'Email', id:'ee'},
            ],
            hoverLeft: false,
            hoverRight: false,
            isMounted: false,
            isZH: false,
            seen: true,
            sliders: [],
            // 业务介绍
            showNav: false,
            navActive: 'aa',
            ywActive: 200,
            ywList: [],
            // 企业文化
            whActive: 0,
            whList: [
                { 
                    active: true,
                    zh:'定製化投放策略', 
                    zhC:'基於客戶需求與遊戲目標受衆畫像，精準選擇匹配的廣告平颱（<br/>如 Google、Facebook 等主流網絡媒體）及投放形式，確保廣告觸達效<br/>率', 
                    en:'Customised advertising strategy', 
                    enC:'Based on customer needs and the target audience profile of<br/>the game, we accurately select matching advertising<br/>platforms (such as Google, Facebook, and other mainstream <br/>online media) and advertising formats to ensure the <br/>effectiveness of advertising reach.'
                },
                {
                    active: false,
                    zh:'創意素材製作', 
                    zhC:'協助客戶打造契合遊戲風格的廣告素材，涵蓋圖文、視頻等多元形<br/>式，增強廣告吸引力', 
                    en:'Creative Asset Production', 
                    enC:"Assisting clients in crafting advertising materials aligned with <br/>the game's aesthetic, encompassing diverse formats such as <br/>graphics and video to enhance advertising appeal"
                },
                {
                    active: false,
                    zh:'全週期賬戶管理', 
                    zhC:'負責廣告賬戶的日常運營、數據監控與效果優化，通過實時分析投放<br/>數據調整策略，持續提昇廣告轉化效果。', 
                    en:'Full-cycle account management', 
                    enC:"Responsible for the day-to-day operation of advertising <br/>accounts, data monitoring and performance optimisation. <br/>Adjust strategies through real-time analysis of campaign data <br/>to continuously enhance advertising conversion rates."
                },
            ],
            // 我們的優勢
            ysActive: 1,
            ysList: [
                {name:'Cooking Sort: <br/>Zooworld', img:'game1.png', imgList:['game1.1.png','game1.2.png','game1.3.png'],link:'https://play.google.com/store/apps/developer?id=crowdstar+studio',},
                {name:'Critter World - Idle <br/>& Bloom!', img:'game2.png', imgList:['game2.1.png','game2.2.png','game2.3.png'],link:'https://play.google.com/store/apps/developer?id=crowdstar+studio',},
                {name:'Fairy Marble Blast', img:'game3.png', imgList:['game3.1.png','game3.2.png','game3.3.png'],link:'https://play.google.com/store/apps/developer?id=crowdstar+studio',},
                {name:'Metal Tycoon', img:'game4.png', imgList:['game4.1.png','game4.2.png','game4.3.png'],link:'https://play.google.com/store/apps/developer?id=crowdstar+studio',},
            ],
            ysList1: [
                {name:'Cooking Sort: <br/>Zooworld', img:'game1.png', imgList:['game1.1.png','game1.2.png','game1.3.png'],link:'https://play.google.com/store/apps/developer?id=crowdstar+studio',},
                {name:'Critter World - Idle <br/>& Bloom!', img:'game2.png', imgList:['game2.1.png','game2.2.png','game2.3.png'],link:'https://play.google.com/store/apps/developer?id=crowdstar+studio',},
                {name:'Fairy Marble Blast', img:'game3.png', imgList:['game3.1.png','game3.2.png','game3.3.png'],link:'https://play.google.com/store/apps/developer?id=crowdstar+studio',},
                {name:'Metal Tycoon', img:'game4.png', imgList:['game4.1.png','game4.2.png','game4.3.png'],link:'https://play.google.com/store/apps/developer?id=crowdstar+studio',},
            ],
            ysList2: [
                {name:'Tile Match', img:'game5.png', imgList:['game5.1.png','game4.2.png','game4.3.png'],link:'https://play.google.com/store/apps/developer?id=Crowdstar&hl=en',},
                {name:'Frontline Strike', img:'game6.png', imgList:['game6.1.png'],link:'https://play.google.com/store/apps/developer?id=Crowdstar&hl=en',},
            ],
            // 简介
            jjActive: 200,
            jjList: [],
        }
    },
    methods: {
        overWH(index) {
            this.whList.forEach((item) => {
                item.active = false;
            });
            this.whList[index].active = true;
        },
        changeGame(){
            if(this.ysActive==1) {
                this.ysActive = 2;
                this.ysList = this.ysList2;
            }else {
                this.ysActive = 1;
                this.ysList = this.ysList1;
            }
            this.activeIndex = 0;
            this.$nextTick(() => {
                if (this.customswiper) {
                    this.customswiper.slideTo(0, 0); // 立即跳转到第一个幻灯片
                    this.customswiper.update(); // 更新 swiper
                }
            });
        },
        toLink(link) {
            window.open(link);
        },
        goPrevSlide() {
            if (this.customswiper) {
                this.customswiper.slidePrev();
                this.activeIndex = this.customswiper.realIndex; 
            }
            },
            goNextSlide() {
            if (this.customswiper) {
                this.customswiper.slideNext();
                this.activeIndex = this.customswiper.realIndex; 
            }
            },
        scrollTo(type) {
            this.navActive = type;
            document.getElementById(type).scrollIntoView({ behavior: 'smooth', block: 'start'})
        },
        menuSeen(){
            // 屏幕尺寸
            let screenHeight=document.body.clientWidth;
            if(screenHeight>415){
                this.seen=true;
            }else{
                this.seen=false;
            }
        },
    },
    mounted() {
        this.isMounted = true;
        this.menuSeen();
        // window.addEventListener('resize', () => {
        //     location.reload();
        // });
        autofit.init({
            designWidth: 1920,
            designHeight: 8090,
            renderDom:"#container",
            ignore: [
                {
                    el: ".head", //必填
                    height: "100px",//可选，需注明单位
                    width: "100%",//可选，需注明单位
                    scale:1, //可选：回放程度，基于主元素缩放后的大小
                    fontSize:26 //可选，如果自定义缩放后文字大小不合适，可以在这里设置文字大小
                },
            ],
            resize: true
        },false) // 可关闭控制台运行提示输出

        // 初始化AOS动画库
        AOS.init({
            duration: 1000, // 动画持续时间
            easing: 'ease-out', // 动画缓动函数
            once: false, // 是否只执行一次
            offset: 100, // 触发动画的偏移量
            delay: 0, // 默认延迟
        });

        // 初始化横向滚动按钮行为
        const buttons = document.querySelectorAll('.jumpButton');
        const indices = {};

        buttons.forEach(button => {
            const targetClass = button.getAttribute('data-target-class');
            indices[targetClass] = 0;

            button.addEventListener('click', () => {
                const targets = document.querySelectorAll(`.${targetClass}`);
                if (targets.length > 0) {
                    targets[indices[targetClass]].scrollIntoView({
                        behavior: 'smooth',
                        // inline: 'start'
                    });
                    indices[targetClass] = (indices[targetClass] + 1) % targets.length;
                }
            });
        });


    },
    destroyed() {
        autofit.off();
    },
    computed: {
        customswiper() {
            let swiper = {};
            if (this.isMounted) swiper = this.$refs.mySwiper.$swiper;
            return swiper;
        },
    },
}
</script>

<style scoped>
@import './index.css';
.btn {
    background: #EA3F30;border-radius: 100px;padding: 4px 10px;font-size: 24px;font-weight: bold;
}
.more {
    border-radius: 42px;border: 2px solid #222222;width: 215px;height:67px;line-height:67px;text-align:center;font-size: 21px;
}
.navbar {
    color:white;font-family: Arial, Arial;font-weight: 900;font-size: 22px;color: #fff;
}
.nav {
    padding: 13px 20px;
    font-family: Space Grotesk;font-weight:bold;font-size: 28px;color: #141831;line-height: 39px;
}
.nav-active {
    background: #AF85E7;
    border-radius: 100px 100px 100px 100px;
    border: 1px solid #000000;
    color: #fff;
}
.navbar-t {
    text-align:center;
    font-family: Poppins, Poppins;
    font-weight: 400;
    font-size: 100px;
    color: #FFFFFF;
    line-height: 140px;
}
.navbar-c {
    text-align:center;
    font-family: Poppins, Poppins;font-size: 32px;color: #DDDDDD;line-height: 51px;font-weight: 400;
}
.navbar-b {
    background: #EA3F30;border-radius: 24px;padding: 29px 44px;font-size: 29px;font-weight: 500;color: #FFFFFF;
}
.navbar-bg{
    width: 100%;
    height: 100%;
    background: url('../../static/b/navbar-bg.png');
    background-size: 100% 100%;
}
.bg-greed {
    background: #D5F277;border-radius: 7px;padding: 12px 21px;display:inline-block;
}
.bg-purple {
    background: #AF84EC;border-radius: 7px;padding: 12px 21px;display:inline-block;
}
.nav-t {
    background: linear-gradient( 272deg, #AF84EC 27%, #D2F26D 76%);border-radius: 100px 100px 100px 100px;border: 2px solid #141831;padding:30px;
}
.main-m {
    width: 40px;height: 12px;background: #EA3F30;border-radius: 100px;margin-bottom: 20px;
}
.main-t {
    font-family: Space Grotesk;font-size: 40px;font-weight: 500;color: #000000;font-weight: bold;
}
.main-c {
    font-family: Manrope, Manrope;font-weight: 400;font-size: 56px;color: #1A1A1A;line-height: 72px;
}
.sub-t {
    font-family: Space Grotesk;font-weight: 500;font-size: 30px;color: #141831;font-weight: bold;
}
.sub-c {
    font-family: Space Grotesk;font-weight: 400;font-size: 23px;color: #141831;line-height: 32px;
}
.menu {
    width:20px;position:absolute;right:24px;top:50%;transform:translateY(-50%);
}

.carousel {
  display: flex;
  /* overflow: hidden; */
  width: 300px;
  height: 100px;
  position: relative;
}

.carousel-item {
  flex: 0 0 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  border: 1px solid #000;
  box-sizing: border-box;
  transition: transform 0.5s ease-in-out;
}

.carousel-item.slide {
  transform: translateX(-100%);
}
.horizontal-scroll-container {
  display: flex;
  overflow-x: auto;
  scroll-behavior: smooth;
  white-space: nowrap;
  padding-top: 20px;
  /* 隐藏滚动条 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.horizontal-scroll-container::-webkit-scrollbar {
  display: none; /* 隐藏滚动条（WebKit/Blink） */
}

.horizontal-slide {
  width: 90%;
  min-width: 1000px; /* 避免缩放 */
  margin-right: 20px;
  flex-shrink: 0;
}

.horizontal-swiper {
  width: 100%;
  /* overflow: hidden; */
}

.swiper-container-horizontal > .swiper-wrapper {
  flex-direction: row; /* 强制横向排列 */
}
.swiper-button-next:after {
display: none;
}
.swiper-button-prev:after {
display: none;
}

.footer-link {
    border-bottom: 1px solid #fff;
    color: #fff;
    text-decoration: none;
    transition: color 0.3s ease, border-color 0.3s ease;
    cursor: pointer;
}

.footer-link:hover {
    color: #D5F277;
    border-color: #D5F277;
}
</style>